import { render, staticRenderFns } from "./SubmissionFormInsuranceInfo.vue?vue&type=template&id=6c40f129&scoped=true&"
import script from "./SubmissionFormInsuranceInfo.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormInsuranceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40f129",
  null
  
)

export default component.exports